<template>
  <div class="best-player">
    <van-form input-align="right">
      <van-field label="所属球队" v-model="teamValue" readonly clickable @click="showTeam = true"></van-field>
      <van-field label="最佳球员" v-model="playerValue" readonly clickable @click="showPlayer = true"></van-field>
    </van-form>
    <van-popup v-model="showTeam" position="bottom" round :style="{ height: '40%' }" >
      <van-picker
        title="所属球队"
        show-toolbar
        :columns="teamColumns"
        @confirm="onConfirmTeam"
        @cancel="showTeam = false"
      >
        <template #option="item">
          {{ item.name }}
        </template>
      </van-picker>
    </van-popup>
    <van-popup v-model="showPlayer" position="bottom" round :style="{ height: '40%' }" >
      <van-picker
        title="最佳球员"
        show-toolbar
        :columns="playerColumns"
        @confirm="onConfirmPlayer"
        @cancel="showPlayer = false"
      >
        <template #option="item">
          {{ item.trueName }}
        </template>
      </van-picker>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import { Popup, Picker, Form, Field } from 'vant'
import { getBMMatchTeamPlayerList } from "@/api/match";
Vue.use(Popup).use(Picker).use(Form).use(Field)
export default {
  name: "best-player",
  model: {
    prop: 'playerId',
    event: 'change'
  },
  props: {
    gameMVPTeamId: {
      type: [String, Number],
      default: ''
    },
    playerId: {
      type: [String, Number],
      default: ''
    },
    teamColumns: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    teamColumns: {
      handler() {
        if (this.gameMVPTeamId !== '') {
          const team = this.teamColumns.find(t => t.id === this.gameMVPTeamId)
          if (team) {
            this.teamId = team.id
            this.teamValue = team.name
            this.getBMMatchTeamPlayerList()
          }
        }
      },
      deep: true
    }
  },
  data() {
    return {
      unionMatchId: '',
      matchId: '',
      teamId: '',
      teamValue: '',
      playerValue: '',
      playerColumns: [],
      showTeam: false,
      showPlayer: false
    }
  },
  mounted() {
    this.matchId = this.$route.query.matchId
    this.unionMatchId = this.$route.params.unionMatchId
  },
  methods: {
    onConfirmTeam(item) {
      this.teamId = item.id
      this.teamValue = item.name
      this.$emit('change', '')
      this.playerValue = ''
      this.showTeam = false
      this.playerColumns = []
      this.getBMMatchTeamPlayerList()
    },
    onConfirmPlayer(item) {
      this.$emit('change', item.id)
      this.playerValue = item.trueName
      this.showPlayer = false
    },
    getBMMatchTeamPlayerList() {
      const params = {
        matchId: this.matchId,
        teamId: this.teamId
      }
      getBMMatchTeamPlayerList(params).then(res => {
        if (res) {
          const { data } = res
          this.playerColumns = data.list || []
          if (this.playerId !== '') {
            const player = this.playerColumns.find(p => p.id === this.playerId)
            if (player) {
              this.playerValue = player.trueName
            }
          }
        }
      })
    }
  }
};
</script>

<style scoped>

</style>
